import Cookies from 'js-cookie';

import ClientStorage from '@fec/frontend/foundation/client/storage';
import { KEYCODES } from '@fec/frontend/foundation/utils/keycodes';
import {
  COMMENTS_LOGGED_IN,
  COMMENTS_TRIGGER_LOGOUT,
  COMMENTS_TRIGGER_LOGIN,
  COMMENTS_TRIGGER_FIND_SESSION,
} from './SrfCommentsEvents';
import { triggerEvent } from '@fec/assets/js/utils/event';

const PJ_ERROR_INVALID_PASSCODE = 'PJ_ERROR_INVALID_PASSCODE';
const PJ_ERROR_INVALID_CODE = 'PJ_ERROR_INVALID_CODE';
const PJ_ERROR_TOO_MANY_ATTEMPTS = 'PJ_ERROR_TOO_MANY_ATTEMPTS';
const PJ_ERROR_PHONENUMBER_ALREADY_USED = 'PJ_ERROR_PHONENUMBER_ALREADY_USED';
const ERROR_MESSAGE_CAPTCHA =
  'Bitte bestätigen Sie die Sicherheitsabfrage, um die Registrierung fortzuführen.';
const ERROR_MESSAGE_INVALID_CODE =
  'Der SMS-Code ist nicht korrekt. Bitte überprüfen Sie Ihre Eingabe.';

export class SrfJanrain {
  constructor() {
    this.isInEditProfileMode = false;
    this.registerListener();
  }

  registerListener() {
    $(document).on('validation:failure', () => this.onValidationFailure());
    $(document).on('login:render', () => this.onLoginRender());
    $(document).on('login:check', () => this.onLoginCheck());
    $(document).on('profile:saved', () => this.onProfileSaved());
    $(document).on('session:found', () => this.onSessionFound());

    $(window).on(COMMENTS_TRIGGER_FIND_SESSION, () => this.onSessionFound());
    $(window).on(COMMENTS_TRIGGER_LOGIN, () => {
      $(document).trigger('login:check');
    });
    $(window).on(COMMENTS_TRIGGER_LOGOUT, () =>
      janrain.capture.ui.endCaptureSession()
    );

    // Click listener on body because some elements are hidden/unavailable at this time
    $(document).on('click', '#mobile-request, #mobile-resend', (e) =>
      this.onSMSTokenRequestClick(e)
    );
    $(document).on('click', '#mobile-response', (e) =>
      this.onVerifySMSTokenClick(e)
    );
    $(document).on('click', '#mail-recheck, #mail-recheck-2', (e) =>
      this.onMailRecheckClicked(e)
    );
    $(document).on('click', '.js-mobile-change-link', (e) =>
      this.onMobileChangeClicked(e)
    );
    $(document).on('click', '#mobile-change-cancel', (e) =>
      this.onMobileChangeCancelled(e)
    );
    $(document).on('click', '#mobile-change-save', (e) =>
      this.onMobileChangeSave(e)
    );
    $(document).on('click', '.js-button-close', (e) =>
      this.onButtonCloseClicked(e)
    );
    $(document).on('click', '#profile-change-save', (e) =>
      this.onProfileChangeSave(e)
    );
    $(document).on('click', '.capture_resendLink', (e) =>
      this.onResendVerificationEmail(e)
    );
    $(document).on('click', '#janrainModal button', (e) =>
      this.onModalButtonClicked(e)
    );

    // adding err message after leaving password-confirm
    $(document).on(
      'focusout',
      '#capture_traditionalRegistration_newPasswordConfirm, #capture_socialRegistration_newPasswordConfirm',
      (e) => this.checkCheckbox()
    );

    $(document)
      .on(
        'change',
        '#capture_traditionalRegistration_privacy, #capture_socialRegistration_privacy',
        (e) => {
          let cssId = $(e.currentTarget).attr('id');
          if ($(e.currentTarget).is(':checked')) {
            this.removeCheckboxError(cssId);
          } else {
            this.addCheckboxError(cssId);
          }
        }
      )
      .on('keyup', '#capture_traditionalRegistration_privacy', (e) => {
        if (e.keyCode === KEYCODES.enter) {
          $(e.currentTarget).click();
        } // un/checking box by pressing <enter>
      });

    $(document).on('keyup', (e) => {
      if (e.keyCode === KEYCODES.escape) {
        janrain.capture.ui.modal.close();
      }
    });
  }

  onValidationFailure() {
    /**
     * If you wonder why this has to be done with a timeout:
     * Janrain resets the whole form after this event, so all modifications are gone. Hence, we wait and THEN modify
     *
     * Alternative could be: Save error in localStorage and afterwards apply to final form
     */
    setTimeout(() => {
      this.checkCheckbox();

      $('[data-elementname="captcha"].capture_tip_error')
        .show()
        .text(ERROR_MESSAGE_CAPTCHA);

      // scroll to captcha error
      if ($('.capture_error').length == 0) {
        let $container;
        let newScrollTop;

        // Mobile
        if ($('#janrainModal').hasClass('js-janrain-mobile')) {
          $container = $('html, body');
          newScrollTop = $('#janrainModal').height() - $(window).height();

          // Desktop
        } else {
          $container = $('.capture_screen_container');
          newScrollTop = $('#janrainModal .tabContent').height();
        }

        $container.animate({ scrollTop: newScrollTop }, 300);
      }
    }, 500);
  }

  onResendVerificationEmail(e) {
    e.preventDefault();
    $(document).trigger('login:check');
  }

  onModalButtonClicked() {
    let $container;
    let newScrollTop;

    // waiting for janrain validation...
    setTimeout(() => {
      const isRegistrationPageVisible =
        $('#traditionalRegistration').css('display') === 'block';

      // check if privacy checkbox is checked on registration page
      if (isRegistrationPageVisible) {
        this.checkCheckbox();
      }

      // If a field is invalid, make sure it's inside the viewable area. If it's not, scroll to it.
      if ($('.capture_error').length > 0) {
        let $firstError = $('.capture_error');

        // Desktop
        if (!$('#janrainModal').hasClass('js-janrain-mobile')) {
          $container = $('.capture_screen_container');

          let isHighEnough =
            $firstError.offset().top + $firstError.outerHeight() <
            $container.offset().top + $container.outerHeight();
          let isLowEnough = $firstError.offset().top > $container.offset().top;

          if (isHighEnough && isLowEnough) {
            return;
          }

          newScrollTop = $container.scrollTop();

          if (!isLowEnough) {
            newScrollTop =
              $container.scrollTop() -
              $container.offset().top +
              $firstError.offset().top;
          } else if (!isHighEnough) {
            newScrollTop =
              $container.scrollTop() +
              ($firstError.offset().top + $firstError.outerHeight()) -
              ($container.offset().top + $container.outerHeight());
          }

          // Mobile
        } else {
          $container = $('html, body');
          newScrollTop = $firstError.offset().top;
        }

        $container.animate({ scrollTop: newScrollTop }, 300);
      }
    }, 500);
  }

  checkCheckbox() {
    let cssId = 'capture_traditionalRegistration_privacy';

    if ($('#socialRegistration').css('display') == 'none') {
      cssId = 'capture_socialRegistration_privacy';
    }

    let $box = $('#' + cssId);
    if ($box.css('display') == 'none') {
      return true;
    }
    if (!$box.is(':checked')) {
      $box.addClass('capture_error');
      this.addCheckboxError(cssId);
    } else if ($box.is(':checked')) {
      $box.removeClass('capture_error');
      this.removeCheckboxError(cssId);
    }
  }

  addCheckboxError(cssId) {
    $('.checkbox-label[for="' + cssId + '"]').addClass('checkbox--on-error');
    $('#' + cssId + '-hint')
      .addClass('form-fieldset__hint--on-error ')
      .removeClass('h-element--hide');
    let parentSelector =
      cssId == 'capture_socialRegistration_privacy'
        ? '#socialRegistration'
        : '#traditionalRegistration';
    $('#janrainModal ' + parentSelector + ' button')
      .addClass('button--inactive')
      .attr('disabled', true);
  }

  removeCheckboxError(cssId) {
    $('#' + cssId + '-hint')
      .removeClass('form-fieldset__hint--on-error ')
      .addClass('h-element--hide');
    let parentSelector =
      cssId == 'capture_socialRegistration_privacy'
        ? '#socialRegistration'
        : '#traditionalRegistration';
    $('#janrainModal ' + parentSelector + ' button')
      .removeClass('button--inactive')
      .removeAttr('disabled');
  }

  onLoginRender() {
    janrain.capture.ui.renderScreen('signIn', true);

    /**
     * Ugly workaround for Apple-Login.
     * We need to change the text of the login-button, otherwise we would see "Sich anmelden als You" in the login screen.
     */
    $('.janrain-provider-text-color-apple').each(function () {
      if ($(this)[0].innerHTML.includes('als You')) {
        $(this)[0].innerHTML = 'Mit Apple anmelden';
      }
    });
  }

  /**
   * Wizard step trigger
   *
   * @param stepName
   * @param screen
   */
  showWizardStep(stepName, screen = 'emailVerificationNotification') {
    $('[data-capturescreenname="' + screen + '"]')
      .children('[data-wizard-step]')
      .hide();
    $('[data-wizard-step="' + stepName + '"]').show();
  }

  /**
   * This is a little helper method to show sub steps. It takes care of the height of the janrain modal.
   *
   * @param screenName
   */
  showSubScreen(screenName) {
    $('[data-wizard-sub-step]').hide();

    let screen = $('[data-wizard-sub-step="' + screenName + '"]');
    screen.show();

    let newModalHeight = $(
      '[data-capturescreenname="emailVerificationNotification"]'
    ).outerHeight();

    $('#janrainModal').height(newModalHeight);
  }

  onLoginCheck() {
    /**
     * The token can expire, the expiration date is set by Janrain and will
     * be checked by Janrain as well. If token expires, Janrain will remove it from local storage.
     */
    if (!janrain.capture.ui.hasActiveSession()) {
      $(document).trigger('login:render');
      return false;
    }

    if (this.isInEditProfileMode) {
      location.reload();
    } else if (SrfJanrainIntegration.isUserVerified()) {
      triggerEvent(COMMENTS_LOGGED_IN, {
        username: SrfJanrainIntegration.getUserName(),
        accessToken: SrfJanrainIntegration.getToken(),
      });
    } else {
      janrain.capture.ui.renderScreen('emailVerificationNotification');
      this.showWizardStep('wizard-loading');
      $.post(
        '/users/check',
        { token: SrfJanrainIntegration.getToken() },
        (data) => this.onUserCheck(data)
      );
    }
  }

  /**
   * If session is active, show logged in name and logout link
   */
  onSessionFound() {
    if (janrain.capture && janrain.capture.ui.hasActiveSession()) {
      triggerEvent(COMMENTS_LOGGED_IN, {
        username: SrfJanrainIntegration.getUserName(),
        accessToken: SrfJanrainIntegration.getToken(),
      });
    }
  }

  onUserCheck(data) {
    if (data.valid) {
      Cookies.set('srf-ls-' + SrfJanrainIntegration.getUserId(), 'verified', {
        path: '/',
      });
      janrain.capture.ui.modal.close();
      triggerEvent(COMMENTS_LOGGED_IN, {
        username: SrfJanrainIntegration.getUserName(),
        accessToken: SrfJanrainIntegration.getToken(),
      });
    } else if (!data.phone) {
      $('[data-placeholder="mobile"]').text(data.phonenumber);
      $('.js-mobile-number-change').val(data.phonenumber);
      this.showWizardStep('mobile');
    } else if (!data.mail) {
      this.showWizardStep('mail');
      $('.js-email-data').text(data.mailaddress);
    }
  }

  onSMSTokenRequestClick(e) {
    e.preventDefault();

    this.showSubScreen('sub-loading-mobile');

    if (SrfJanrainIntegration.getUserId()) {
      $.ajax(
        '/users/' + SrfJanrainIntegration.getUserId() + '/sms-verifications',
        {
          success: (data) => {
            window.srfVerificationToken = data.token;
            this.showSubScreen('response');
          },
          error: (data) => this.onSMSRequestError(data),
          type: 'post',
          dataType: 'json',
          contentType: 'application/json',
        }
      );
    }
  }

  onVerifySMSTokenClick(e) {
    e.preventDefault();

    let verificationCode = $('#mobile-code').val();
    let verificationToken = window.srfVerificationToken;

    this.showSubScreen('sub-loading-mobile');

    if (
      SrfJanrainIntegration.getUserId() &&
      verificationCode &&
      verificationToken
    ) {
      let payload = {
        verificationToken: verificationToken,
        verificationCode: verificationCode,
      };

      $.ajax(
        '/users/' +
          SrfJanrainIntegration.getUserId() +
          '/sms-verifications/verify',
        {
          success: () => {
            janrain.capture.ui.modal.close();
            $(document).trigger('login:check');
          },
          error: (data) => this.onSMSVerificationError(data),
          type: 'post',
          dataType: 'json',
          data: JSON.stringify(payload),
          contentType: 'application/json',
        }
      );
    } else {
      this.showWizardStep('error');
    }
  }

  onSMSVerificationError(request) {
    switch (request.status) {
      case 403:
        let $subStep = $('[data-wizard-sub-step="response"]');

        switch (request.responseJSON.error.code) {
          case PJ_ERROR_INVALID_PASSCODE:
            this.hideCustomErrors();
            $('#mobile-error-too-many-validation-attempts').show();

            $subStep.find('label').removeClass('input-field--on-error');
            $subStep.find('input').val('').removeClass('input-field--on-error');
            $subStep.find('.input-field-hint').remove();

            this.showSubScreen('request');
            break;

          case PJ_ERROR_INVALID_CODE:
            let errorSpan = $(
              '<span class="input-field-hint input-field--on-error"></span>'
            );
            errorSpan.text(ERROR_MESSAGE_INVALID_CODE);

            $subStep.find('label').addClass('input-field--on-error');
            $subStep.find('input').addClass('input-field--on-error');
            $subStep.find('.input-field-hint').remove();
            $subStep.find('input').after(errorSpan);

            this.showSubScreen('response');
            break;

          default:
            this.showWizardStep('error');
        }

        break;
      case 404:
        this.showWizardStep('error');
        // Keeping comment here so we know what kind of error popped up
        // console.warn('User with user id ' + SrfJanrainIntegration.getUserId() + ' does not exist');
        break;
      case 422:
        this.showWizardStep('error');
        // Keeping comment here so we know what kind of error popped up
        // console.warn('Verification ok, but user couldn't be updated');
        break;
      default:
        this.showWizardStep('error');
        break;
    }
  }

  onProfileSaved() {
    setTimeout(() => {
      this.showWizardStep('profile-saved', 'editProfile');
    }, 500);
  }

  onProfileChangeSave() {
    this.isInEditProfileMode = true;
    $(document).trigger('login:check');
  }

  onResendVerificationEmail(e) {
    e.preventDefault();
    $(document).trigger('login:check');
  }

  onSMSRequestError(request) {
    switch (request.status) {
      case 403:
        switch (request.responseJSON.error.code) {
          case PJ_ERROR_TOO_MANY_ATTEMPTS:
            this.hideCustomErrors();
            $('#mobile-error-too-many-requests').show();

            this.disableSMSVerificationButton();

            this.showSubScreen('request');

            break;

          case PJ_ERROR_PHONENUMBER_ALREADY_USED:
            // This can only happen if janrain user is deleted by admin
            this.showSubScreen('request-phone-number-used');
            break;

          default:
            this.hideCustomErrors();
            $('#mobile-error-technical-error').show();

            this.showSubScreen('request');
        }
        break;

      default:
        this.showWizardStep('error');
        break;
    }
  }

  onMailRecheckClicked(e) {
    e.preventDefault();
    janrain.capture.ui.modal.close();
    $(document).trigger('login:check');
  }

  onMobileChangeClicked(e) {
    e.preventDefault();
    this.showWizardStep('change-mobile-number');
  }

  onMobileChangeCancelled(e) {
    e.preventDefault();
    this.showWizardStep('mobile');
  }

  onMobileChangeSave(e) {
    e.preventDefault();
    this.showWizardStep('wizard-loading');

    let payload = {
      mobile: $('.js-mobile-number-change').val(),
      token: SrfJanrainIntegration.getToken(),
    };

    $.ajax('/users/account/email', {
      success: () => {
        this.hideCustomErrors();

        $('#mobile-change-number').removeClass('input-field--on-error');

        $(document).trigger('login:check');
      },
      error: (response) => {
        $('#mobile-change-number').addClass('input-field--on-error');
        this.showWizardStep('change-mobile-number');

        switch (response.status) {
          case 422:
            $('.js-input-field-hint--used').show();
            break;
          default:
            this.showWizardStep('error');
            break;
        }
      },
      type: 'post',
      dataType: 'json',
      data: JSON.stringify(payload),
      contentType: 'application/json',
    });
  }

  onButtonCloseClicked(e) {
    e.preventDefault();
    janrain.capture.ui.modal.close();
    return false;
  }

  hideCustomErrors() {
    $('.js-janrain-error').hide();
  }

  disableSMSVerificationButton() {
    $('#mobile-request').prop('disabled', true).addClass('button--inactive');
  }
}

class SrfJanrainIntegration {
  static getToken() {
    return ClientStorage.getItem('janrainCaptureToken', false);
  }

  static getUserName() {
    let data = ClientStorage.getItemJsonParsed(
      'janrainCaptureReturnExperienceData'
    );
    return data ? data.displayName : false;
  }

  static getUserId() {
    let data = ClientStorage.getItemJsonParsed('janrainCaptureProfileData');
    return data ? data.uuid : false;
  }

  static isUserVerified() {
    let isVerified = false;
    if (
      janrain &&
      janrain.capture &&
      janrain.capture.ui.hasActiveSession() &&
      SrfJanrainIntegration.getUserId() &&
      Cookies.get('srf-ls-' + SrfJanrainIntegration.getUserId()) === 'verified'
    ) {
      isVerified = true;
    }
    return isVerified;
  }
}
